import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';

global.requestAnimationFrame = global.requestAnimationFrame
  || function requestAnimationFrame(callback) {
    setTimeout(callback, 0);
  };
